import { Domain } from '../../../../config.types';
import {
  ConfiguracoesMarca,
  ConfiguracoesMarcaServiceResponse,
} from '../../service/consultar-configuracoes-marca.types';

export const configuracoesMapper = (dados: ConfiguracoesMarcaServiceResponse, domain: Domain): ConfiguracoesMarca => {
  if (domain === 'aluno') {
    return {
      BIBLIOTECA_VIRTUAL: dados.aluno.bibliotecaVirtual.map((item) => ({
        title: item.titulo,
        url: item.url,
        descricao: item.descricao,
      })),
      CALENDARIO_ACADEMICO: dados.aluno.calendarioAcademico,
      OPCOES_MENU_AJUDA: dados.aluno.opcoesMenuAjuda,
      MODALIDADES_ELEGIVEIS_AVALIACAO_AURA: dados.aluno.modalidadesElegiveisAvaliacaoAura,
      MODALIDADES_ELEGIVEIS_EXERCICIOS: dados.aluno.modalidadesElegiveisExercicios,
      DISCIPLINAS_ELEGIVEIS_EXERCICIOS: dados.aluno.disciplinasElegiveisExercicios,
      DISCIPLINAS_ELEGIVEIS_MAPEAMENTO_COMPETENCIAS: dados.aluno.disciplinasElegiveisMapeamentoCompetencias,
      URL_TERMS: dados.aluno.urlTermos,
      BANNERS_COMUNICACAO: dados.aluno.bannersComunicacao,
      URL_BDQ_ALUNO: dados.aluno.urlBdq,
      URL_BDQ_EDUCADOR: undefined,
      ONBOARDING: dados.aluno.onboarding,
      URL_CRIATIVA_HUMANA: dados.aluno.urlCriativaHumana,
      URL_CAMPUS_SIA: dados.urlCampusSia,
      TURMAS_MVP_SIRIUS: dados.aluno.turmasMVPSirius,
      HABILITAR_CURSOS_COMPLEMENTARES: dados.aluno.habilitarCursosComplementares,
      CURSOS_LIVRES: dados.aluno.cursosLivres,
      HABILITAR_CURSOS_LIVRES: dados.aluno.habilitarCursosLivres,
    };
  }

  return {
    BIBLIOTECA_VIRTUAL: dados.educador.bibliotecaVirtual.map((item) => ({
      title: item.titulo,
      url: item.url,
      descricao: item.descricao,
    })),
    CALENDARIO_ACADEMICO: dados.educador.calendarioAcademico,
    OPCOES_MENU_AJUDA: dados.educador.opcoesMenuAjuda,
    MODALIDADES_ELEGIVEIS_AVALIACAO_AURA: [],
    MODALIDADES_ELEGIVEIS_EXERCICIOS: undefined,
    DISCIPLINAS_ELEGIVEIS_EXERCICIOS: undefined,
    DISCIPLINAS_ELEGIVEIS_MAPEAMENTO_COMPETENCIAS: undefined,
    URL_TERMS: dados.educador.urlTermos,
    BANNERS_COMUNICACAO: [],
    URL_BDQ_ALUNO: undefined,
    URL_BDQ_EDUCADOR: dados.educador.urlBdq,
    ONBOARDING: dados.aluno.onboarding,
    URL_CRIATIVA_HUMANA: undefined,
    URL_CAMPUS_SIA: dados.urlCampusSia,
    TURMAS_MVP_SIRIUS: dados.aluno.turmasMVPSirius,
    HABILITAR_CURSOS_COMPLEMENTARES: false,
    CURSOS_LIVRES: undefined,
    HABILITAR_CURSOS_LIVRES: undefined,
  };
};
